import React, { useState, useEffect } from "react";
import Navbar from "../component/NavBar";
import { useParams, useNavigate } from "react-router-dom";
import { getProductById } from "../Api/services/ProductsService";
import { AddToCart } from "../Api/services/CartServices";
import Loader from "../component/common/Loader";
import Footer from "../component/Footer";
import toast, { Toaster } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { addToCart } from "../slices/cart.slice";

const ProductPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [productData, setProductData] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const[loading,setLoading]=useState(false)

  const fetchProduct = async () => {
    try {
      const res = await getProductById(id);
      console.log(res.data.product)
      setProductData(res.data.product);
    } catch (err) {
      toast.error(err?.message || "something went wrong")
      console.error(err.message);
    }
  };

  useEffect(() => {
    if (id) {
      fetchProduct();
    }
  }, [id]);

  useEffect(() => {
    if (productData) {
      setSelectedImage(productData?.images[0]);
      setSelectedSize(productData?.size[0]?.size);
    }
  }, [productData]);

  const handleAddToCart = async (product) => {
    const token = localStorage.getItem("token");
    if (!token) {
      localStorage.setItem("redirectAfterLogin", window.location.pathname);
      toast.error("Please login to add items to cart");
      navigate("/login");
      return;
    }
    setLoading(true)
    try {
      const response = await AddToCart(token, {
        productId: product._id,
        size: selectedSize,
        quantity: 1,
      });
      
      if (response.status === 201) {
        toast.success("Product added to cart");
        dispatch(addToCart());
        navigate("/cart")
      }
    } catch (error) {
      console.error("Add to cart error:", error);
      toast.error(error?.response?.data?.message || "Failed to add to cart");
    }
    setLoading(false)
  };

  if (!productData) {
    return (
      <div className="flex justify-center items-center">
        <Loader />
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <Toaster position="top-right" />
      <div className="max-w-7xl mx-auto p-4 lg:flex lg:gap-8">
        {/* Left Section - Images */}
        <div className="lg:w-1/2">
          <img
            src={selectedImage}
            alt={productData.title}
            className="w-full md:w-[80%] h-[650px] rounded-md object-cover flex-shrink-0"
          />
          <div className="overflow-x-auto mt-4">
            <div className="flex gap-2">
              {productData.images.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Thumbnail ${index}`}
                  className={`w-20 h-28 cursor-pointer rounded-lg border object-cover ${selectedImage === image
                    ? "border-blue-500"
                    : "border-gray-300"
                    }`}
                  onClick={() => setSelectedImage(image)}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Right Section - Details */}
        <div className="lg:w-1/2 mt-6 lg:mt-0">
          <h1 className="text-2xl font-bold mb-2">{productData?.title}</h1>
          <p className="text-xl text-gray-700 mb-2 line-through">
            Rs. {productData?.originalPrice}
          </p>
          <p className="text-xl text-gray-700 mb-2 font-semibold">
            Rs. {productData?.discountedPrice}
          </p>
          {productData.discount ? (
            <p className="text-green-500 mb-4">
              Get {productData?.discount}% Off
            </p>
          ) : null}

          {/* Sizes */}
          <div className="mb-4">
            <h2 className="font-bold mb-2">Size</h2>
            <div className="flex gap-2">
              {productData.size.map((sizeObj) => (
                <button
                  key={sizeObj.size}
                  className={`border px-4 py-2 rounded-lg transition-colors 
                    ${selectedSize === sizeObj.size ? "bg-[#a20204] text-white" : "hover:bg-gray-100"}
                    ${!sizeObj.inStock ? "opacity-50 cursor-not-allowed" : ""}`}
                  onClick={() => sizeObj.inStock && setSelectedSize(sizeObj.size)}
                  disabled={!sizeObj.inStock}
                >
                  {sizeObj.size}
                  {!sizeObj.inStock && <p className="text-xs">Out of Stock</p>}
                </button>
              ))}
            </div>
          </div>

          {/* Color */}
          <div className="mb-4">
            <h2 className="font-bold mb-2">Color</h2>
            <p>{productData.color}</p>
          </div>

          {/* Material */}
          <div className="mb-4">
            <h2 className="font-bold mb-2">Material</h2>
            <p>{productData.material}</p>
          </div>

          <p className="text-gray-700 mb-4">By {productData.brand}</p>
          <p className="text-gray-600 mb-4">{productData.description}</p>

          {!productData.inStock && (
            <p className="text-red-500 font-semibold mb-4">Product Out of Stock</p>
          )}

          <button
            onClick={() => handleAddToCart(productData)}
            className={`bg-[#a20204] text-white px-6 py-3 rounded-lg hover:bg-[#000000] transition-colors w-full mb-4 
              ${(loading || !productData.inStock) ? "cursor-not-allowed opacity-50" : ""}`}
            disabled={!selectedSize || loading || !productData.inStock}
          >
            {!productData.inStock 
              ? "Out of Stock" 
              : localStorage.getItem("token") 
                ? `${loading ? "Loading..." : "Add to Cart"}` 
                : "Login to Add to Cart"}
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ProductPage;
